import React from 'react';

import Header from 'components/Header/Header';

import './Tabs.scss';

interface IProps {
  tabContent: JSX.Element;
}

export const Tabs = ({tabContent}: IProps) => {
  return (
    <section aria-label="tab list section" className="tabs">
      <div className="tabs__header">
        <Header titles={['Pub Page Editors']} />
      </div>
      <div className="tab__body">{tabContent}</div>
    </section>
  );
};
